export default __webpack_public_path__ + "static/media/nudo.1c1b546b.png";